var React = require('react');

function TickBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.6656 19.1907L21.7945 8.75766C22.1354 8.36801 22.7277 8.32852 23.1174 8.66947C23.507 9.01042 23.5465 9.6027 23.2056 9.99236L13.3618 21.2424C12.9851 21.6729 12.3139 21.6686 11.9428 21.2331L7.724 16.2831C7.38815 15.8891 7.43534 15.2973 7.82941 14.9615C8.22347 14.6256 8.81519 14.6728 9.15104 15.0669L12.6656 19.1907Z","fill":"#63B8FF"}));
}

TickBlue.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = TickBlue;

TickBlue.default = TickBlue;
